import type { RemotePhoto } from 'components/PhotoBank/PhotoBank.types'
import { DEFAULT_THUMB_CROP, type ThumbCrop } from 'stores/cartStore/CartItem'
import type { CartUpsellThumbnail } from '../cartUpsells.types'
import {
  getTileMiniStyle,
  type UpsellTile,
  type UpsellWall,
} from '../upsellWall'
import type { AiWallOffer } from './aiWall.schemas'
import {
  getPhotoPreviewUrl,
  isPrivatePhotoUrl,
} from 'components/PhotoBank/PhotoBank.utils'
import { PHOTO_PREVIEW_SIZES } from 'components/PhotoBank/PhotoBank.consts'

// An offer is kept for hours, longer than its signed preview lasts; a result in the private bucket is shown through
// its preview link instead, which doesn't expire
function getResultThumbUrl({
  url,
  preview,
}: AiWallOffer['results'][number]): string {
  return isPrivatePhotoUrl(url)
    ? getPhotoPreviewUrl(url, PHOTO_PREVIEW_SIZES.HIGH)
    : preview
}

export function getAiWallThumbnail({
  tile,
  offer,
  sourcePhoto,
  sourceCrop,
}: {
  tile: UpsellTile
  offer: AiWallOffer
  sourcePhoto: RemotePhoto
  sourceCrop: ThumbCrop
}): CartUpsellThumbnail {
  return {
    type: 'tile-before-after',
    source: { imageUrl: sourcePhoto.lowResUrl, crop: sourceCrop },
    resultTile: {
      ...getTileMiniStyle(tile),
      thumbUrl: getResultThumbUrl(offer.results[0]),
      crop: DEFAULT_THUMB_CROP,
    },
  }
}

export function getAiWallWall(
  tile: UpsellTile,
  offer: AiWallOffer
): UpsellWall {
  return {
    tileStyle: getTileMiniStyle(tile),
    photos: offer.results.map((result) => ({
      thumbUrl: getResultThumbUrl(result),
      crop: DEFAULT_THUMB_CROP,
    })),
  }
}
